import Route from 'cio/routes/base';
import RouterService from '@ember/routing/router-service';
import { inject as service } from '@ember/service';
import EnvironmentService from 'cio/services/environment';

export default class SnippetsRedirectRoute extends Route {
  @service environment!: EnvironmentService;
  @service router!: RouterService;

  redirect() {
    this.router.transitionTo('snippets');
  }
}
